import type { ReactNode } from "react";
import { useMe } from "../api/me";
import type { Features } from "../api/types";
import { NotFoundPage } from "../pages/NotFoundPage";
import { Skeleton } from "../ui";

/** A route of a feature that may be switched off. While `/v1/me` is in flight
 *  it shows a skeleton, never a flash of "Not found"; a feature that is off
 *  (or an older API that names none) renders the not-found page. */
export function RequireFeature({
  name,
  children,
}: {
  name: keyof Features;
  children: ReactNode;
}) {
  const me = useMe();
  if (me.isPending) return <Skeleton width="100%" height={240} />;
  if (me.data?.features?.[name]) return <>{children}</>;
  return <NotFoundPage />;
}
